<div fxLayout="column" class="neq-dialog">
    {{'msg.common.validation.modified' | translate}}
    <br>
    {{'msg.common.validation.continue' | translate}}
    <div class="asi-container" fxLayout="row" fxLayoutAlign="center center">
      <button pButton class="neq-primeng-button-text" label="{{'msg.common.validation.yes' | translate}}" (click)="continue()"></button>
      <button pButton class="neq-primeng-button-text" label="{{'msg.common.validation.no' | translate}}" (click)="goBack()"></button>
    </div>
</div>
